import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SERVICES } from "@/lib/site";

const card = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: (i % 3) * 0.08, duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-14 flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <div>
            <p className="font-sans text-xs font-bold uppercase tracking-[0.2em] text-zi-accent">
              What we do
            </p>
            <h2 className="mt-4 max-w-2xl font-heading text-4xl font-bold tracking-tight text-zi-ink sm:text-5xl lg:text-6xl">
              Our Services.
            </h2>
          </div>
          <p className="max-w-sm font-sans text-base text-zi-muted">
            A full suite of BPO and administrative services, each shaped around
            how your business actually runs.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                data-testid={`service-card-${i}`}
                custom={i}
                variants={card}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-40px" }}
                whileHover={{ y: -6 }}
                className="group flex flex-col overflow-hidden rounded-3xl border border-zi-line bg-white shadow-sm transition-all duration-300 hover:border-zi-primary/30 hover:shadow-xl hover:shadow-zi-primary/10"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-zi-ink/60 to-transparent" />
                  <div className="absolute left-4 top-4 flex h-11 w-11 items-center justify-center rounded-xl bg-white/95 text-zi-primary shadow-md">
                    <Icon size={22} />
                  </div>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-heading text-xl font-bold tracking-tight text-zi-ink">
                    {s.title}
                  </h3>
                  <p className="mt-2 font-sans text-sm leading-relaxed text-zi-muted">
                    {s.desc}
                  </p>
                  <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-2">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-center gap-1.5 font-sans text-xs text-zi-ink">
                        <Check size={13} className="flex-none text-zi-accent" strokeWidth={3} />
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
